import { render, staticRenderFns } from "./stationControlPanelButton.vue?vue&type=template&id=22b9153b&scoped=true&"
import script from "./stationControlPanelButton.vue?vue&type=script&lang=js&"
export * from "./stationControlPanelButton.vue?vue&type=script&lang=js&"
import style0 from "./stationControlPanelButton.vue?vue&type=style&index=0&id=22b9153b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b9153b",
  null
  
)

export default component.exports